export enum BackgroundTaskReportTypes {
  OUTBOUND = 'outbound',
  INBOUND = 'inbound'
}
